function FullPageWrapper({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`overflow-x-hidden h-full ${className}`}>{children}</div>
  );
}

export default FullPageWrapper;
